import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getObjectLength} from "../../../../utils/functions"

class DepartmentSide extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record
		// console.log(fullText);
		// console.log(this.props.facet);
		return (
			<div className="right-side-group">
				{/*<div className="mt-px-n15 pt-px-20 pb-px-20 border-bottom border-lightgray">*/}
				{/*	<h4 className="con-title">*/}
				{/*		<a href="#" className="d-flex align-items-center color-black">*/}
				{/*			<span className="icon icon-size-16 icon-graph-blue mr-2" />*/}
				{/*			2021 통계(준비중)*/}
				{/*			<span className="icon icon-size-16 icon-more-arrow-blue ml-auto" />*/}
				{/*		</a>*/}
				{/*	</h4>*/}
				{/*</div>*/}
				{/*<div className="pt-px-20 pb-px-20 border-bottom border-lightgray">*/}
				{/*	<h4 className="con-title">*/}
				{/*		<a href="#" className="d-flex align-items-center color-black">*/}
				{/*			<span className="icon icon-size-16 icon-document-blue mr-2" />*/}
				{/*			통계 분석(준비중)*/}
				{/*			<span className="icon icon-size-16 icon-more-arrow-blue ml-auto" />*/}
				{/*		</a>*/}
				{/*	</h4>*/}
				{/*</div>*/}
				{record.homepage &&
				<div className="pt-px-20 pb-px-20 border-bottom border-lightgray">
					<h4 className="con-title">
						<a href={record.homepage} className="d-flex align-items-center color-black" target="_blank">
							<span className="icon icon-size-16 icon-home-blue mr-2"/>학과 홈페이지
							<span className="icon icon-size-16 icon-more-arrow-blue ml-auto"/>
						</a>
					</h4>
				</div>
				}
				{record.tel &&
				<div className="pt-px-20 pb-px-20 border-bottom border-lightgray">
					<h4 className="con-title">
						<a href={"tel:" + record.tel} className="d-flex align-items-center color-black">
							<span className="icon icon-size-16 icon-tel-blue mr-2"/>{record.tel}
							<span className="icon icon-size-16 icon-more-arrow-blue ml-auto"/>
						</a>
					</h4>
				</div>
				}
				{record.gps &&
				<div className="pt-px-20 pb-px-20 border-bottom border-lightgray">
					<h4 className="con-title">
						<a href={record.gps} className="d-flex align-items-center color-black" target="_blank">
							<span className="icon icon-size-16 icon-map-blue mr-2"/>
							학과 위치보기
							<span className="icon icon-size-16 icon-more-arrow-blue ml-auto"/>
						</a>
					</h4>
				</div>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.departments.record ? state.departments.record : {},
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(DepartmentSide)

DepartmentSide.propTypes = {
	// fullText : PropTypes.array,
};
